// extracted by mini-css-extract-plugin
export default {"list":"ProductCardTags_list__exHxD"};